export const SiteEnv = {
    API_SERVER_HOSTNAME: () => process.env.REACT_APP_API_SERVER_HOSTNAME,
    WEB_VERSION: () => process.env.REACT_APP_WEB_VERSION,
    BACKEND_VERSION: () => process.env.REACT_APP_BACKEND_VERSION,
    RESOLVE_ROUTE_FOR_WORDPRESS: () => process.env.REACT_APP_RESOLVE_ROUTE_FOR_WORDPRESS === "true",
};